let swiperThumbs = null;
let swiperMain = null;

// THUMBS
document.querySelectorAll('.Index_top_hero_slideshows_list_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {

    const totalSlides = el.querySelectorAll('.swiper-slide').length;

    swiperThumbs = new Swiper(el, {
      loop: true,
      loopedSlides: totalSlides,
      spaceBetween: 20,
      slidesPerView: 7,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      direction: 'vertical',
      breakpoints: {
        0: {
            spaceBetween: 8,
            slidesPerView: "auto",
            direction: 'horizontal',
            freeMode: false // 🔥 IMPORTANT
        },
        750: {
            spaceBetween: 10,
            slidesPerView: 7,
            direction: 'vertical'
        },
        990: {
            spaceBetween: 12,
            slidesPerView: 7
        },
        1200: {
        },
        1440: {
          spaceBetween: 20,
        }
      }
    });
  }
});

// MAIN
document.querySelectorAll('.Index_top_hero_slideshows_item_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {

    const totalSlides = el.querySelectorAll('.swiper-slide').length;

    swiperMain = new Swiper(el, {
      loop: true,
      loopedSlides: totalSlides,
      slidesPerView: 1,
      effect: "fade",
      speed: 300,
      fadeEffect: {
          crossFade: true,
      },

      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // ✅ let Swiper handle everything
      thumbs: {
        swiper: swiperThumbs,
      }
    });
  }
});

// 👇 Hover logic
document.querySelectorAll('.Index_top_hero_slideshows_list_slider .swiper-slide')
.forEach((slide, index) => {
  slide.addEventListener('mouseenter', () => {
    if (swiperMain) {
      swiperMain.slideToLoop(index); // important for loop mode
    }
  });
});